import React from 'react'
import Nopgcomp, { } from '../components/Nopgcomp'
const NoPage = () => {
    return (
        <Nopgcomp />
    )
}

export default NoPage;